import { createAsyncThunk } from '@reduxjs/toolkit';
import assetServiceApiInstance from '../../../../config/assetApiConfig';

// Create Maintenance
export const createMaintenance = createAsyncThunk(
    'assetMaintenance/create',
    async (data: any, { rejectWithValue }) => {
        try {
            const res = await assetServiceApiInstance.post('/asset-maintenance', data);
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create maintenance record');
        }
    }
);

// Fetch All
export const fetchAllMaintenances = createAsyncThunk(
    'assetMaintenance/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const res = await assetServiceApiInstance.get('/asset-maintenance');
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch maintenance records');
        }
    }
);

// Fetch By ID
export const fetchMaintenanceById = createAsyncThunk(
    'assetMaintenance/fetchById',
    async (id: number, { rejectWithValue }) => {
        try {
            const res = await assetServiceApiInstance.get(`/asset-maintenance/${id}`);
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch maintenance record');
        }
    }
);

// Update
export const updateMaintenance = createAsyncThunk(
    'assetMaintenance/update',
    async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
        try {
            await assetServiceApiInstance.put(`/asset-maintenance/${id}`, data);
            return { id, data };
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update maintenance record');
        }
    }
);

// Delete
export const deleteMaintenance = createAsyncThunk(
    'assetMaintenance/delete',
    async (id: number, { rejectWithValue }) => {
        try {
            await assetServiceApiInstance.delete(`/asset-maintenance/${id}`);
            return id;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete maintenance record');
        }
    }
);

// Fetch Maintenance Records by Employee ID
export const fetchMaintenancesByEmployeeId = createAsyncThunk(
  'assetMaintenance/fetchByEmployee',
  async (employeeId: number, { rejectWithValue }) => {
    try {
      const res = await assetServiceApiInstance.get(`/asset-maintenance/employee/${employeeId}`);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch maintenance records by employee');
    }
  }
);

// Fetch Maintenance Records by Supervisor Hierarchy
export const fetchAssetMaintenanceBySupervisorHierarchy = createAsyncThunk(
  'assetMaintenance/fetchAssetMaintenanceBySupervisorHierarchy',
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await assetServiceApiInstance.get(
        `/asset-maintenance/supervisor/${supervisorId}`,
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch supervisor hierarchy asset maintenance'
      );
    }
  }
);
